<template>
	<div>
		<span v-if="valid" class="start">
			<template v-if="patient.hasOwnProperty('first_event') && patient.first_event[type]">
				{{ formatEventDate(patient.first_event[type]) }}
			</template>
			<template v-else-if="firstEvent">
				{{ formatDate(firstEvent.time || firstEvent.created) }}
			</template>
			<!-- {{ firstDate }} -->
		</span>
		<template v-if="valid && multiday">
			<span>-</span>
			<span class="end">
				<template v-if="patient.hasOwnProperty('last_event') && patient.last_event[type]">
					{{ formatEventDate(patient.last_event[type]) }}
				</template>
				<template v-else-if="lastEvent">
					{{ formatDate(lastEvent.time || firstEvent.created) }}
				</template>
			</span>
		</template>
	</div>
</template>

<script>
import Column from '.'

export default {
	name: 'event-date-range-column',
	extends: Column,

	props: {
		patient: {
			type: Object,
			required: true
		},
		timeKey: {
			type: String,
			default: 'time'
		},
		type: {
			type: String,
			default: ''
		}
	},

	computed: {
		valid() {
			return Array.isArray(this.row.event) && this.row.event.length > 0
		},
		firstEvent() {
			return this.row.event[0]
		},
		firstPatientEventDate() {
			if (this.patient.hasOwnProperty('first_event') && this.patient.first_event[this.type])
				return this.formatEventDate(this.patient.first_event[this.type])
		},
		firstDate() {
			return this.formatDate(this.firstEvent[this.timeKey], true)
		},
		firstYear() {
			return new Date(this.firstEvent[this.timeKey]).getYear()
		},
		lastEvent() {
			return this.row.event[this.row.event.length - 1]
		},
		lastPatientEventDate() {
			if (this.patient.hasOwnProperty('last_event') && this.patient.last_event[this.type])
				return this.formatEventDate(this.patient.last_event[this.type])
		},
		lastDate() {
			if (this.lastEvent)
				return this.formatDate(this.lastEvent[this.timeKey], true)
		},
		lastYear() {
			if (this.lastEvent)
				return new Date(this.lastEvent[this.timeKey]).getYear()
		},
		multiday() {
			// There is more than 1 event from 2 or more distinct days (year comparison is necessary since
			// the date does not include year and could, in a very unlikely situation, match a previous year)
			return this.row.event.length > 1 &&
				 (this.firstDate != this.lastDate || this.firstYear != this.lastYear)
		}
	}
}
</script>
<style lang="scss" scoped>
strong {
	font-weight: 500;
}
span {
	color: #7f7f7f;
}
</style>
